import * as React from 'react'
import SlideNav from './components/SlideNav';
import SlideNavItem from './components/SlideNavItem';
import Controls from './components/Controls';
import ProgressBar from './components/ProgressBar';
import "./carousel.css";

const SLIDE_DURATION = 10000;

function Carousel(props): React.ReactElement {
  const [isHidden, setIsHidden] = React.useState(true);
  return (
    <section className="gmcngine-carousel" aria-label="Images or elements to be displayed" onMouseEnter={() => setIsHidden(false)} onMouseLeave={() => setIsHidden(true)}>
      {props.children}
      {props.withSlidesNav &&
        <SlideNav>
          {props.children.map((slide, index) => (
            <SlideNavItem
              key={index}
              isCurrent={index === props.currentIndex}
              aria-label={`Slide ${index + 1}`}
              onClick={(): void => props.onGoTo(index)}
            />
          ))}
        </SlideNav>
      }
      {props.withControls &&
        <Controls
          isPlaying={props.isPlaying}
          onPlay={props.onPlay}
          onPause={props.onPause}
          onNext={props.onNext}
          onPrev={props.onPrev}
          isHidden={isHidden}
        />
      }
      {props.withProgressBar && 
        <ProgressBar
          key={props.currentIndex + props.isPlaying}
          time={SLIDE_DURATION}
          animate={props.isPlaying}
          isHidden={isHidden}
        />
      }
    </section>
  )
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/share/components/Carousel/Carousel.tsx